import { Link } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import CenterTypeBadge from './CenterTypeBadge'
import { usePatientStats } from '../../hooks/usePatientStats'
import type { CenterApplicationInfoOut } from '../../types/centerApplicationTypes'
import type { CenterType } from '../../constants/centerTypes'

interface ApplicationTableRowProps {
  application: CenterApplicationInfoOut
}

export default function ApplicationTableRow({
  application
}: ApplicationTableRowProps) {
  const { totalSCPatients, totalSCAPatients } = usePatientStats(application)

  return (
    <tr className="border-b border-gray-200 hover:bg-gray-50">
      <td className="p-4">
        <Link
          to={`/admin/applications/${application.id}`}
          className="text-[#142841] hover:text-[#A6410A] font-medium"
        >
          {application.center_name}
        </Link>
      </td>
      <td className="p-4">
        <CenterTypeBadge
          centerType={application.center_type as CenterType}
          size="sm"
        />
      </td>
      <td className="p-4 text-sm text-gray-600">
        {application.city}, {application.state}
      </td>
      <td className="p-4 text-sm text-gray-600">
        <div>SC: {totalSCPatients}</div>
        <div>SCA: {totalSCAPatients}</div>
      </td>
      <td className="p-4 text-sm text-gray-600">
        {application.second_approval_at
          ? new Date(application.second_approval_at).toLocaleDateString()
          : 'N/A'}
      </td>
      <td className="p-4">
        {application.is_associate ? (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            Associate
          </span>
        ) : (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <CheckCircleIcon className="w-3 h-3 mr-1" />
            Full Member
          </span>
        )}
      </td>
      <td className="p-4 text-center">
        <Link
          to={`/admin/applications/${application.id}`}
          className="inline-flex items-center px-3 py-1 text-sm font-medium text-[#142841] bg-[#EDE6DE] hover:bg-[#E0D4C4] rounded transition-colors"
        >
          View Details
        </Link>
      </td>
    </tr>
  )
}
